import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const AB_PRINCIPLES = [
    {
        n: '01',
        word: 'Anything goes.',
        body: 'If a person will pay for it and another will do it, it belongs on Interim. A fourth for a five-a-side, a hand with the shopping, a guide for a new city — post it.',
    },
    {
        n: '02',
        word: 'No gatekeepers.',
        body: 'No agency in the middle. No CV gauntlet. No interview rounds. You see a job, you take it; you post a job, someone takes it. The platform stays out of the way.',
    },
    {
        n: '03',
        word: 'Momentum.',
        body: 'The hardest job is the first one. After that, the next is easier. The whole product is built around getting you to that first paid hour as fast as possible.',
    },
];

const AboutUs = () => {
    const navigate = useNavigate();

    return (
        <div className="ab-page">
            <main>

                {/* ── HERO ── */}
                <section className="ab-hero">
                    <div className="ix-container ab-hero-grid">
                        <aside className="ab-hero-rail">
                            <div className="ab-rail-eyebrow mono">About Interim</div>
                        </aside>

                        <div className="ab-hero-body">
                            <h1 className="ab-hero-headline">
                                People are the point.<br />
                                Work is the <em>way.</em>
                            </h1>
                            <div className="ab-hero-lede">
                                <p>
                                    Interim is a faster way for people to find paid work, and
                                    for paid work to find people. One platform, one tap,
                                    same-day pay. Whatever the job, whoever you are.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ── MISSION STATEMENT ── */}
                <section className="ab-statement">
                    <div className="ix-container">
                        <p className="ab-statement-text">
                            Our mission is to <em>empower</em> people — not replace them —
                            by providing a fast, flexible way to earn money through
                            short-term, real-world work.
                        </p>
                    </div>
                </section>

                {/* ── PRINCIPLES ── */}
                <section className="ab-principles">
                    <div className="ix-container">
                        <header className="ab-section-head">
                            <span className="ab-eyebrow mono">Three things we hold to</span>
                            <h2 className="ab-h2">
                                The principles we<br />
                                <em>keep coming back to.</em>
                            </h2>
                        </header>

                        <ol className="ab-principles-list">
                            {AB_PRINCIPLES.map(v => (
                                <li key={v.n} className="ab-principle">
                                    <div className="ab-principle-n mono">{v.n}</div>
                                    <div className="ab-principle-body">
                                        <h3 className="ab-principle-word">{v.word}</h3>
                                        <p className="ab-principle-text">{v.body}</p>
                                    </div>
                                </li>
                            ))}
                        </ol>
                    </div>
                </section>

                {/* ── VISION PULL-QUOTE ── */}
                <section className="ab-vision">
                    <div className="ix-container">
                        <div className="ab-vision-frame">
                            <span className="ab-vision-quote-mark" aria-hidden>"</span>
                            <span className="ab-eyebrow mono ab-vision-eyebrow">Our vision</span>
                            <blockquote className="ab-vision-quote">
                                Doing your first job is the hardest step. After that,
                                <em> momentum follows.</em> If we make that step easier —
                                for anyone, doing anything, anywhere — then technology has
                                done what it ought to: <em>reduced</em> unemployment
                                instead of causing it.
                            </blockquote>
                        </div>
                    </div>
                </section>

                {/* ── CTA ── */}
                <section className="ab-cta">
                    <div className="ix-container">
                        <div className="ab-cta-row">
                            <div>
                                <span className="ab-eyebrow mono">Your move</span>
                                <h2 className="ab-cta-title">
                                    Read enough? <em>Pick up</em> your first job.
                                </h2>
                            </div>
                            <div className="ab-cta-actions">
                                <button
                                    className="ix-btn ix-btn-primary ix-btn-lg"
                                    onClick={() => navigate('/get-job')}
                                    style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
                                >
                                    Find work <ArrowRight size={16} />
                                </button>
                                <button
                                    className="ix-btn ix-btn-outline ix-btn-lg"
                                    onClick={() => navigate('/create-job')}
                                >
                                    Post a job
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
        </div>
    );
};

export default AboutUs;
